export default __webpack_public_path__ + "static/media/professional.ce76cc04.png";